import Filter from './Filter';
import React, { useEffect, useState } from 'react';
import { Card, InputBase, Stack } from '@mui/material';
import { digitsFaToEn } from '@persian-tools/persian-tools';

export default function Search({ init, setFilter, clearFilter }) {
  const [title, setTitle] = useState(init?.title || '');
  const handleChange = (e) => setTitle(digitsFaToEn(e.target.value));

  useEffect(() => {
    let search = setTimeout(() => {
      if (title) {
        setFilter({ username: title });
      }
    }, 1000);
    return () => clearTimeout(search);
  }, [title]);

  return (
    <Stack top={0} zIndex={1} width="100%" position="sticky" bgcolor="transparent">
      <Card
        elevation={4}
        sx={{
          p: 1,
          height: 64,
          columnGap: 0.5,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          borderRadius: '0 0 16px 16px',
        }}
      >
        <InputBase
          autoFocus
          value={title}
          onChange={handleChange}
          placeholder="جستجو..."
          sx={{ flex: 1, color: 'text.secondary' }}
          inputProps={{ 'aria-label': 'جستجو...' }}
        />
        <Filter init={init} setFilter={setFilter} clearFilter={clearFilter} />
      </Card>
    </Stack>
  );
}
